module.exports = __webpack_public_path__ + "img/bg.d6a6117a.png";